import React from 'react'
import './Navbar.css'
import Toggle from '../../components/Toggle/Toggle'
import { Link } from 'react-scroll'


function Navbar() {
  return (
      <div className="n-wrapper">
          <div className="n-left">
            <div className="n-name">
                Niketan
            </div>
            <Toggle />
          </div>
          <div className="n-right">
            <div className="n-list">
                <ul>
                    <Link spy={true} to='Navbar' smooth={true} activeClass='activeClass'>
                    <li>Home</li>
                    </Link>
                    <Link spy={true} to='Services' smooth={true}>
                    <li>Services</li>
                    </Link>
                    <Link spy={true} to='Protfolio' smooth={true}>
                    <li>Protofolio</li>
                    </Link>
                    <Link spy={true} to='ContactMe' smooth={true}>
                    <li>Support</li>
                    </Link>
                </ul>
            </div>
            <a href='mailto: niketan.kcn@gmail.com' style={{width: 'max-content'}}>
              <button className='button n-btn'>Contact</button>
            </a>
          </div>
      </div>
    )
}

export default Navbar